import { APIData, appFetch } from ".";

type Image = {
  id: number;
  image: string;
  created_at: string;
};

export interface NewsItem {
  id: 1;
  title: string;
  description: string;
  image: string;
  is_in_main_news: 0 | 1;
  created_at: string;
  images: Image[];
}

export const newsAPI = {
  fetchPage(page: number) {
    return appFetch<APIData<NewsItem[]>>("/news?page=" + page);
  },
  fetchItem(id: number) {
    return appFetch<APIData<NewsItem>>("/news/" + id);
  },
};
